'use client';

import { IDGenerator, SymplifySDK } from '@symplify-conversion/sst-sdk-nodejs/lib/client';
import { createContext, ReactNode, useMemo } from 'react';
import useConfig from '@hooks/useConfig';

type SymplifyContextType = {
  sstInstance?: SymplifySDK;
};

export const SymplifyContext = createContext<SymplifyContextType>({});

interface SymplifyContextProviderProps {
  children: ReactNode;
}
const SymplifyContextProvider = ({ children }: SymplifyContextProviderProps) => {
  const { config } = useConfig();

  const contextValue = useMemo(() => {
    if (!config?.SYMPLIFY_WEBSITE_ID) return {} as SymplifyContextType;

    return {
      sstInstance: new SymplifySDK(config.SYMPLIFY_WEBSITE_ID, {
        idGenerator: (() => crypto.randomUUID()) as IDGenerator,
        log: undefined,
        httpGET: async (url: string) => fetch(url).then((res) => res.text()),
      }),
    };
  }, [config]);
  return <SymplifyContext.Provider value={contextValue}>{children}</SymplifyContext.Provider>;
};

export default SymplifyContextProvider;
